import React from "react";

const LogoMarquee = () => {
  const logos = ["Airbnb", "VRBO", "Booking.com"];

  return (
    <div className="py-12 bg-muted/20 border-y border-border/50 overflow-hidden relative">
      {/* Edge fade masks */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-muted/20 to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-muted/20 to-transparent z-10" />

      <div className="container mx-auto px-4 mb-6">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          Your Property Will Be Listed On Leading Platforms
        </p>
      </div>
      <div className="flex overflow-hidden group">
        <div className="flex animate-marquee whitespace-nowrap py-4 [will-change:transform] group-hover:[animation-play-state:paused]">
          {[...logos, ...logos, ...logos, ...logos].map((logo, i) => (
            <span
              key={i}
              className="mx-12 text-2xl font-heading font-bold text-muted-foreground/40 hover:text-primary transition-colors cursor-default"
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoMarquee;
